import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const DetailsFlex = styled.div`
    display: flex;
`;

export const DealerDetailsFlex = styled.div`
    display: flex;
    flex: 2;
    flex-direction: column;
`;

export const Name = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #040222;
`;

export const Phone = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #040222;
    margin-top: 4px;
`;

export const DeleteIconFlex = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
`;

export const Hr = styled.div`
    display: flex;
    width: 100%;
    height: 0;
    border: 1px solid #e7e7f0;
    margin-top: 10px;
`;
